// Base URL configuration based on environment
export const BASE_URL = process.env.REACT_APP_API_BASE_URL;
console.log("BASE_URL:", BASE_URL);

// For reference:
// Development: https://dev.api.booz.life/
// Production: https://api.booz.life/
// Previous One: http://176.46.153.96:7005